import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { useLocalStorage } from "@uidotdev/usehooks";
import { Link } from "react-router-dom";

const SustainabilityInDairyFarm = () => {
  const [storedName] = useLocalStorage("name", null);

  const { brandData, loading, errors } = useTraceabilityData();

  // Get brand name from context, fallback to default
  const brandName = brandData?.logo?.brandName || "Our Brand";
  const productName = brandData?.logo?.productName || "";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Sustainability in Dairy Farms</h2>
      </div>

      {/* Intro Section */}
      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.brand && "Loading brand information..."}
                {!loading.brand && errors.brand && (
                  <span>Error loading brand information.</span>
                )}
                {!loading.brand && !errors.brand && (
                  <>
                    At <strong>{brandName}</strong>, sustainability is at the core of everything we
                    do. We work closely with our farmers to adopt eco-friendly
                    practices, ensuring minimal impact on the environment. From
                    solar-powered milk collection and chilling centres to electric
                    vehicles for milk delivery, we are committed to a greener
                    future, reducing carbon emissions and promoting responsible
                    farming.
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sustainability Highlights */}
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">

            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/sd1-min.png" alt="Biogas" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Biogas for
                  <br />
                  Clean Energy
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/sd2-min.png" alt="Eco-friendly Farming" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Eco-friendly
                  <br />
                  Farming Support
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/sd3-min.png" alt="Solar powered Milk collection center" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Solar powered Milk
                  <br />
                  collection center
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/sd4-min.png" alt="Cattle productivity improvement" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Cattle productivity
                  <br />
                  improvement
                </h6>
              </div>
            </div>


            <div className="product-item col">
              <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img src="img/sd5-min.png" alt="Methane emission reduction" className="card-img-top" />
                <h6
                  className="fw-normal"
                  style={{ fontSize: "12px", textAlign: "center", paddingTop: "10px", color: "black" }}
                >
                  Methane emission
                  <br />
                  reduction
                </h6>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Dairy Farm Insights */}
      {/* <div className="bg-light" style={{ marginTop: "-20px" }}>
        <div className="container p-3">
          <div className="underline2 my-3 mx-1"></div>

          <h6 className="card-title fw-bold my-2 mx-1">Dairy Farm Insights</h6>

          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <a href="meet-our-cows">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box1.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Cattle
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="meet-the-farmers">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box2.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Farmers
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustanibilty-in-dairy-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box3.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Sustainability in Dairy Farms
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="open-housing-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box4.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                      Learn About Open House Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="farm-improvement-services">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box5.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3" style={{ top: "30%" }}>
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Farm Improvement Services
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="smart-farming">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box6.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Smart Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/meet-the-farmers"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/open-housing-farm"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>

      {/* Traceability Journey */}
      {/* <div className="wrapper2">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div>

      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />

            <ProductItem
              href="milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />

            <ProductItem
              href="quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />

            <ProductItem
              href="manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />

            <ProductItem
              href="distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />

            <ProductItem
              href="it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SustainabilityInDairyFarm;

